import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
export default function PrivateOutlet(children) {
  const { currentUser } = useAuth();
  return currentUser ? <Outlet /> : <Navigate to="/" replace />;
  // return currentUser ? <Outlet /> : <Outlet />;
}
